<template>
  <main>
    <section class="admin-page">
      <div class="admin-toolbar">
        <div class="admin-selector">
          <v-icon small color="text_secondary" class="mr-2">mdi-map-marker</v-icon>
          <v-select
            v-model="cod_praca"
            :items="pracas"
            item-text="sig_praca"
            item-value="cod_praca"
            placeholder="Escolha uma praça"
            solo
            flat
            dense
            hide-details
            @change="onChange"
            background-color="surface_tertiary"
            class="admin-select"
          />
        </div>
        <div v-show="cod_praca">
          <ModalInserirCamera :cod-praca="cod_praca" />
        </div>
      </div>
      <div class="admin-table-wrapper">
        <DataTables
          v-if="cameras"
          :data="cameras.items"
          :headers="headers"
          tab="cameras"
          :fetchData="fetchData"
        />
      </div>
    </section>
  </main>
</template>

<script>
import DataTables from "../components/DataTables.vue";
import { mapGetters, mapActions } from "vuex";
import ModalInserirCamera from "@/components/Modal/Camera/ModalInserirCamera.vue";
export default {
  name: "CamerasAdminView",
  components: { DataTables, ModalInserirCamera },
  data() {
    return {
      page: 1,
      size: 20,
      cod_praca: null,
      filtro_texto: "",
      headers: [
        {
          text: "Nome",
          align: "start",
          sortable: false,
          name: "nome",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Endereço",
          align: "start",
          sortable: false,
          name: "endereco",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Ação",
          sortable: false,
          class: "subtitle-1 font-weight-bold",
          value: "name",
          name: "action",
          align: "end",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      cameras: "cameras/getterCamerasPraca",
      pracas: "pracas/getterPracas",
    }),
  },
  async created() {
    await this.getPracas();
    await this.fetchData();
  },
  methods: {
    ...mapActions({
      getPracas: "pracas/getPracas",
      getCamerasByPraca: "cameras/getCamerasByPraca",
    }),
    async fetchData() {
      try {
        await this.getCamerasByPraca({
          page: this.page,
          size: this.size,
          cod_praca: this.cod_praca,
          filtro_texto: this.filtro_texto,
        });
      } catch (error) {
        this.$toast.error("Erro ao buscar câmeras.");
      }
    },
    async onChange(e) {
      this.cod_praca = Number(e);
      await this.getCamerasByPraca({
        page: this.page,
        size: this.size,
        cod_praca: this.cod_praca,
        filtro_texto: this.filtro_texto,
      });
    },
  },
};
</script>

